module.exports = __webpack_public_path__ + "static/img/18.82d73be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/eng/18.png
// module id = Cr30
// module chunks = 0